import { BaseTable } from '@sede-enterprise/shell-ds-react-framework';
import React, { useState } from 'react';
import { SortingState, getSortedRowModel } from '@tanstack/react-table';
import { ICustomColumn, ImportedDeals } from '../../Types/types';
import { convertCarbonEmissionInMTPA } from '../ScenerioModelling/util1';

interface ImportedDealsTableProps {
  importedDeals: ImportedDeals[];
  cols: ICustomColumn[];
}

const ImportedDealsTable: React.FC<ImportedDealsTableProps> = ({ importedDeals, cols }) => {
  const updatedImportedDeals = importedDeals.map((deal) => {
    const { CARBON_EMISSION_UNIT } = deal;
    return CARBON_EMISSION_UNIT === 'MTPA' ? deal : convertCarbonEmissionInMTPA(deal);
  });

  const [sorting, setSorting] = useState<SortingState>([]);
  const tableOptions = {
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
  };

  return (
    <BaseTable
      className='imported-deals-table'
      stickyHeader
      stickyFooter
      useColumnsSizing
      maxHeight={400}
      columns={cols}
      data={updatedImportedDeals}
      tableOptions={tableOptions as unknown as Object}
    />
  );
};

export default ImportedDealsTable;
